import React from "react";
import { SparklesIcon } from "lucide-react";
import { MockupSlot } from "./MockupSlot";
import { LeafSprig } from "./decor/LeafSprig";
import { activityPages } from "../data/landing";
export function ActivityBookSection() {
  return <section className="relative overflow-hidden bg-leaf-light" data-id="element-1" data-mp="3boo2qxcoeo53">
      <LeafSprig className="pointer-events-none absolute -right-3 top-8 w-20 rotate-[100deg] md:w-24" data-id="element-2" data-mp="3fnww413t0k04" />
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 md:py-24 lg:grid-cols-2 lg:gap-16" data-id="element-3" data-mp="78mt8qs3bara">
        <div data-id="element-4" data-mp="c6og7msmzu81">
          <h2 className="font-display text-[1.85rem] font-extrabold uppercase leading-[1.1] text-royal md:text-[2.6rem]" data-id="element-5" data-mp="c7g225wfmdl4">
            Le Grand Cahier
            <span className="block text-leaf-deep" data-id="element-6" data-mp="36rwlzl3tlju">d’Activités Bibliques</span>
          </h2>
          <p className="mt-4 font-display text-xl font-semibold leading-snug text-tangerine-dark md:text-2xl" data-id="element-7" data-mp="2iyp5ieobvkpc">
            Parce que les enfants apprennent aussi en jouant, en dessinant et en partageant.
          </p>
          <p className="mt-5 leading-relaxed text-cocoa md:text-lg" data-id="element-8" data-mp="1rx4sgx572mk">
            Prolongez les enseignements des paraboles avec des activités à imprimer, pensées
            pour encourager la réflexion, l’expression des émotions et les échanges en famille.
          </p>
          <div className="mt-8 flex gap-4 rounded-[1.75rem] border-[3px] border-tangerine bg-white px-6 py-5" data-id="element-9" data-mp="6rt96h9r4w2n">
            <SparklesIcon className="mt-1 h-6 w-6 shrink-0 text-sun" aria-hidden="true" data-id="element-10" data-mp="kr2o7dm81k51" />
            <p className="font-display text-lg font-bold leading-snug text-royal-deep md:text-xl" data-id="element-11" data-mp="fsrdz1s0l7ma">
              Lisez une parabole, découvrez sa leçon et continuez à explorer son message
              ensemble.
            </p>
          </div>
        </div>

        <div data-id="element-12" data-mp="pit0hp4pyhz3">
          <div className="grid grid-cols-3 gap-3 md:gap-4" data-id="element-13" data-mp="pkdwzkalgazl">
            {activityPages.map((page, i) => <MockupSlot key={i} src={page.src} label={page.title} hint="Bientôt disponible" className={`aspect-[3/4] w-full bg-white/80 p-2 ${i === 1 ? "-translate-y-3" : ""}`} data-id="element-14" data-mp="13fpqjod0jvex" data-mpi={i} />)}
          </div>
          <p className="mt-5 text-center text-sm font-semibold text-cocoa-soft" data-id="element-15" data-mp="1ghuw5r3f8vtq">
            Aperçu des pages du cahier présenté dès leur finalisation.
          </p>
        </div>
      </div>
    </section>;
}